import FJTextToSpeechRight from '../view/FJTextToSpeechRight.jsx';
import useLocalStore from '../../../../hooks/useLocalStore.js';
import { useSelector, useDispatch } from 'react-redux';
import FJActionTextToSpeech from '../../../../redux/action/FJActionTextToSpeech.js';

const FJTextToSpeechRightContainer = () => {
    useLocalStore();
    const dispatch = useDispatch();
    const currentSpeechList = useSelector(state => state.textToSpeech.currentSpeechList);
    const speechSelectId = useSelector(state => state.textToSpeech.speechSelectId);

    const _updateSpeechListPosition = (id, index) => {
        dispatch(FJActionTextToSpeech.updateSpeechListPositionAction(id, index));
    };

    const _onSelect = id => {
        dispatch(FJActionTextToSpeech.setSliceSpeechSelectIdAction(id));
        dispatch(FJActionTextToSpeech.updateVoiceInfoAction());
    };

    return (
        <FJTextToSpeechRight
            currentSpeechList={currentSpeechList}
            updateSpeechListPosition={_updateSpeechListPosition}
            onSelect={_onSelect}
            speechSelectId={speechSelectId}
        />
    );
};
export default FJTextToSpeechRightContainer;
